/* eslint-disable camelcase, jsx-a11y/no-noninteractive-element-interactions,@typescript-eslint/camelcase */
import React, { Component } from 'react';
import get from 'lodash/get';
import PropTypes from 'prop-types';
import { sanitize as sanitizeHtml } from 'dompurify';
import { Bar, Wrapper, Logo } from './TopNavStyles';
import { StyledButton } from '../../CommonComponents/Button';
import ClientMenu from '../Components/ClientMenu/ClientMenuContainer';
import Tooltip from '../../CommonComponents/Tooltip';
import { ROUTES_WITH_TRANSPARENT_BACKGROUND } from './TopNavConstants';
import { Help } from '../Components/Help/Help';
import { Box } from '../../CommonComponents/OPL/Box/Box';
import { ClientCombobox } from '../../ClientSearch/components/ClientCombobox/ClientCombobox';
import { AddClientModal } from '../../AddClientModal/AddClientModal';

class TopNavView extends Component {
  constructor(props) {
    super(props);
    const { fetch_data, is_initialized, notifications_on } = this.props;
    if (!is_initialized && notifications_on) {
      fetch_data();
    }

    this.state = {
      notification_open: false,
      isBurgerMenuOpen: false,
      isAddClientModalOpen: false,
    };

    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.setIsAddClientModalOpen = this.setIsAddClientModalOpen.bind(this);
  }

  componentDidMount() {
    const { notifications_on, set_timer, fetch_data } = this.props;

    document.addEventListener('click', this.handleClickOutside, true);

    if (notifications_on) {
      set_timer(
        setInterval(() => {
          fetch_data();
        }, ADV.settings.misc.notification_update_frequency),
      );
    }
  }

  componentWillUnmount() {
    const { clear_timer } = this.props;

    document.removeEventListener('click', this.handleClickOutside, true);

    clear_timer();
  }

  handleClickOutside(event) {
    if (!this.notificationsDropdownRef || !this.notificationsDropdownRef.contains(event.target)) {
      this.setState({
        notification_open: false,
      });
    }

    if (!this.burgerDropdownRef || !this.burgerDropdownRef.contains(event.target)) {
      this.setState({
        isBurgerMenuOpen: false,
      });
    }
  }

  setIsAddClientModalOpen(isOpen) {
    this.setState({ isAddClientModalOpen: isOpen });
  }

  render() {
    const {
      absolute_logo_url,
      client,
      notifications,
      showAdminAreaLink,
      unread_count,
      mark_all_read,
      settings_on,
      notifications_on,
      route,
      whiteLabelDashboardLogoCssStyle,
      showFinancialPlanning,
      canSendFeedback,
    } = this.props;

    const { notification_open, isBurgerMenuOpen, isAddClientModalOpen } = this.state;

    const { id: routeName } = ADV.util.Router.getObjFromHash(ADV.util.getHash());
    const isClientSearch = routeName === 'ClientSearch';
    const hasClient = !client; // There are more pages that dont have client ID!
    const isTransparent = ROUTES_WITH_TRANSPARENT_BACKGROUND.includes(get(route, 'controller'));

    return (
      <>
        <div id="AdviserTopNavBar" className={client ? 'client-selected' : ''}>
          <Bar isTransparent={isTransparent}>
            <Wrapper>
              <>
                <Logo
                  className={`logo${absolute_logo_url ? ' show_custom_logo' : ''}`}
                  onClick={() => ADV.util.Router.go2('ClientSearch', {})}
                  data-route="search_client"
                  onKeyDown={() => {}}
                  role="button"
                  tabIndex="0"
                  whiteLabelDashboardLogoCssStyle={whiteLabelDashboardLogoCssStyle}
                  whiteLabelLogoUrl={absolute_logo_url}
                />

                {client && <ClientMenu />}

                <div className={`left-buttons${absolute_logo_url ? ' has-white-label' : ''}`}>
                  <Tooltip
                    tag="div"
                    tooltipchildren="Home"
                    orientation="bottom"
                    className="left-buttons__tooltip"
                  >
                    <StyledButton.Link
                      data-route="search_client"
                      prependIcon="fa fa-home"
                      size="big"
                      className="left-buttons__button"
                      aria-label="home"
                    />
                  </Tooltip>

                  {!isClientSearch && (
                    <Box ml={20} width={390}>
                      <ClientCombobox
                        key={`client-combobox--${client ? client.Id : 'no-client'}`}
                      />
                    </Box>
                  )}

                  <Tooltip
                    tag="div"
                    tooltipchildren="Add Client"
                    orientation="bottom"
                    className="left-buttons__tooltip"
                  >
                    <StyledButton.Link
                      onClick={() => this.setIsAddClientModalOpen(true)}
                      appendIcon="fas fa-plus-circle"
                      size="big"
                      className="left-buttons__button"
                      aria-label="add client"
                    />
                  </Tooltip>
                </div>

                <ul id="ToprightMenu">
                  {!hasClient && showFinancialPlanning && (
                    <li className="button-item">
                      <div className="button-item__container">
                        <Tooltip tag="div" tooltipchildren="Download PDF" orientation="bottom">
                          <StyledButton.Link
                            prependIcon="fas fa-download"
                            size="big"
                            className="right-buttons__button"
                            aria-label="download pdf"
                            onClick={() =>
                              ADV.util.Router.go2('AdvancedPDF', { clientId: client.Id })
                            }
                          />
                        </Tooltip>
                      </div>
                    </li>
                  )}
                  {!hasClient && showFinancialPlanning && (
                    <li className="button-item">
                      <div className="button-item__container">
                        <Tooltip tag="div" tooltipchildren="Present" orientation="bottom">
                          <StyledButton.Link
                            prependIcon="fa fa-desktop"
                            size="big"
                            className="right-buttons__button"
                            aria-label="present"
                            onClick={() =>
                              window.open(
                                `${ADV.settings.endpoints.api}Consumer/Consumer?isPresentationMode=true&clientId=${client.Id}`,
                                '_blank',
                              )
                            }
                          />
                        </Tooltip>
                      </div>
                    </li>
                  )}
                  {notifications_on && (
                    <li
                      tabIndex="0"
                      id="btn-notification"
                      className={`${notification_open ? 'open' : ''} ${
                        unread_count ? 'has-notifications' : ''
                      }`}
                      onClick={event => {
                        if (event.target.tagName.toLowerCase() === 'a') {
                          this.setState({ notification_open: false });
                        } else {
                          this.setState({ notification_open: true });
                          mark_all_read();
                        }
                      }}
                      ref={node => (this.notificationsDropdownRef = node)}
                    >
                      {!!unread_count && <span className="badge">{unread_count}</span>}

                      <i className={`fa fa-bell${unread_count ? ' red' : ''}`} />

                      <ul className="adv-dropdown notifications adv-scrollbars">
                        <li className="header">Notifications</li>

                        {!!notifications.length &&
                          notifications.map(notification => (
                            <li
                              key={notification.NotificationId}
                              className={notification.IsRead ? '' : 'unread'}
                            >
                              <p
                                className="message"
                                dangerouslySetInnerHTML={{
                                  __html: sanitizeHtml(notification.Message),
                                }}
                              />
                              <p className="date">{notification.TimeSinceCreation}</p>
                            </li>
                          ))}

                        {!notifications.length && (
                          <li className="empty">
                            <p>You don&apos;t have any recent notifications.</p>
                          </li>
                        )}
                      </ul>
                    </li>
                  )}

                  <Help />

                  <li
                    className={`user ${isBurgerMenuOpen ? 'open' : ''}`}
                    onClick={event =>
                      this.setState({
                        isBurgerMenuOpen: event.target.tagName.toLowerCase() !== 'a',
                      })
                    }
                    ref={node => (this.burgerDropdownRef = node)}
                  >
                    <i className="fa fa-bars" />

                    <ul className="adv-dropdown user_menu">
                      {settings_on && (
                        <li
                          onClick={() =>
                            ADV.util.Router.go2('AdviserSettings', { page: 'MySettings' })
                          }
                        >
                          <i className="fa fa-cog" />
                          Settings
                        </li>
                      )}

                      {showAdminAreaLink && (
                        <li data-action="Go2AdminArea">
                          <i className="fa fa-users" />
                          Admin Area
                        </li>
                      )}

                      {canSendFeedback && (
                        <li data-action="Feedback">
                          <i className="fa fa-comment" />
                          Send Feedback
                        </li>
                      )}

                      <li className="border-top" data-action="logout" data-params>
                        <i className="fa fa-sign-out-alt" />
                        Log Out
                      </li>
                    </ul>
                  </li>
                </ul>
              </>
            </Wrapper>
          </Bar>
        </div>

        {isAddClientModalOpen && (
          <AddClientModal onClose={() => this.setIsAddClientModalOpen(false)} />
        )}
      </>
    );
  }
}

TopNavView.defaultProps = {
  client: null,
};

TopNavView.propTypes = {
  client: PropTypes.shape({
    Id: PropTypes.number,
  }),
  canSendFeedback: PropTypes.bool.isRequired,
};

export default TopNavView;
